// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"d8c03ab5","202":"b3b4d618","206":"00a94c5b","222":"5e708b10","230":"6c8a3b01","324":"9e18b8fa","383":"13861223","505":"f5f8f557","509":"437d6be8","614":"956abadf","728":"7e09203c","821":"16fce118","831":"6487d522","906":"935f9a76"}[chunkId] + ".chunk.js";
};